site.registerService('PageEvents', function () {
    "use strict";

    function PageEvents() {
        this.events = {};
    }

    PageEvents.prototype.trigger = function (name) {
        var handlers = this.events[name];
        if (handlers) {
            for (var i = 0; i < handlers.length; i++) {
                var handler = handlers[i];
                handler();
            }
        }
    };

    PageEvents.prototype.on = function (name, handler) {
        this.events[name] = this.events[name] || [];
        this.events[name].push(handler);
    };

    PageEvents.prototype.off = function (name, handler) {
        var handlers = this.events[name];
        if (handlers) {
            var index = handlers.indexOf(handler);
            if (index !== -1) {
                handlers.splice(index, 1);
            }
        }
    };


    PageEvents.prototype.onDebounced = function(name, handler, delay) {
        var debounced = site.debounce(handler, delay);
        this.on(name, debounced);
    };


    // export
    return new PageEvents();

});